var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stockitems',{attrs:{"stockitems":_vm.stockItems,"stocktypes":_vm.stockTypes},on:{"stockItemChange":function($event){return _vm.getStockItems()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }